import {
  Datagrid,
  List,
  ListProps,
  SearchInput,
  TextField,
} from 'react-admin';
import { CsvReportOpenButton } from './CsvReportOpenButton';
import { resourceNames } from '../constants';

const filters = [
  <SearchInput
    alwaysOn
    key="search"
    source="q"
  />,
];

export const CsvReportList = (props: ListProps) => (
  <List
    {...props}
    bulkActionButtons={false}
    filters={filters}
    perPage={25}
    resource={resourceNames.ADMIN_CSV_REPORT}
    sort={{ field: 'id', order: 'asc' }}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <CsvReportOpenButton />
    </Datagrid>
  </List>
);
